import * as React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    Box, Grid, Stack, IconButton, Tooltip,
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import QrCodeIcon from "@mui/icons-material/QrCode";
import DataKPIPanel from "../../components/dashboard/kpi/DataKPIPanel";
import UsageMapPanel from "../../components/dashboard/usage-map/UsageMapPanel";
import RankingPanel from "../../components/dashboard/ranking/RankingPanel";
import PlayActivityPanel from "../../components/dashboard/activity/PlayActivityPanel";
import VideoThumbsListPanel from "../../components/dashboard/video/VideoThumbsListPanel";
import Footer from "../../layout/home/footer";
import SkillpassportQRLoginDialog from "../../components/dashboard/SkillpassportQRLoginDialog";

export default function DashboardView() {
    const location = useLocation();
    const [settingOpen, setSettingOpen] = useState(false);
    const [qrcodeOpen, setQrcodeOpen] = useState(false);

    useEffect(() => {
        if (location.state?.openQrLogin) {
            setQrcodeOpen(true);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    const handleSettingOpen = () => setSettingOpen(true);
    const handleSettingClose = () => setSettingOpen(false);

    const handleQrcodeOpen = () => setQrcodeOpen(true);
    const handleQrcodeClose = () => setQrcodeOpen(false);

    return (
        <Box sx={{ height: "100vh", width: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            {/* Setting Dialog */}
            <Dialog open={settingOpen} onClose={handleSettingClose} maxWidth="sm" fullWidth>
                <DialogTitle>Settings</DialogTitle>
                <DialogContent>
                    {/* TODO: add setting controls here */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSettingClose}>Close</Button>
                </DialogActions>
            </Dialog>

            {/* QR Code Login Dialog */}
            <SkillpassportQRLoginDialog open={qrcodeOpen} onClose={handleQrcodeClose} />

            <Grid container sx={{ flex: 1, height: "100%" }}>
                {/* Left Column: KPI Panel + Usage Map Panel */}
                <Grid item xs={7} sx={{ display: "flex", flexDirection: "column", height: "100%", backgroundColor: "#161722", borderRight: "3px solid #000" }}>
                    {/* KPI Panel - narrow top strip */}
                    <Box sx={{ flex: "0 0 auto", borderBottom: "3px solid #161722" }}>
                        <Stack direction="row" alignItems="center" >
                            <Tooltip title="Settings">
                                <IconButton onClick={handleSettingOpen} sx={{ ml: 1 }}>
                                    <SettingsIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="QR Code">
                                <IconButton onClick={handleQrcodeOpen} sx={{ ml: 0.5 }}>
                                    <QrCodeIcon />
                                </IconButton>
                            </Tooltip>
                            <DataKPIPanel />
                        </Stack>
                    </Box>

                    {/* Usage Map Panel - fills remaining left space */}
                    <Box sx={{ flex: 1, overflow: "hidden" }}>
                        <UsageMapPanel />
                    </Box>
                    {/* Video Thumbs List Panel - below usage map */}
                    <Box sx={{ flex: "0 0 auto" }}>
                        <VideoThumbsListPanel />
                    </Box>
                </Grid>

                {/* Right Column: Ranking Panel + Play Activity Panel */}
                <Grid item xs={5} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    {/* Ranking Panel - top half */}
                    <Box sx={{ flex: 2, borderBottom: "3px solid #000", overflow: "hidden" }}>
                        <RankingPanel />
                    </Box>
                    {/* Play Activity Panel - bottom half */}
                    <Box sx={{ flex: 1, overflow: "hidden" }}>
                        <PlayActivityPanel />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
